import styled from 'styled-components';

import { StyledComponent } from '../../interfaces';

export const LogoItem: StyledComponent<'img'> = styled.img`
  width: 130px;
  max-width: 100%;
`;

export const LogoItemSymbol: StyledComponent<'img'> = styled.img`
  height: 28px;
  max-width: 100%;
`;
